/** A date as the date picker's masked field holds it: `MM/DD/YYYY` or `DD/MM/YYYY`. */
import type { IsoDate } from "./calendarMath";
import { isIsoDate, parse } from "./calendarMath";
import type { IDateOrder } from "./dateLocale";

const FULL = /^(\d{2})\/(\d{2})\/(\d{4})$/;

export function writeInputDate(date: IsoDate, order: IDateOrder): string {
  const { year, month, day } = parse(date);
  const mm = String(month).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  const yyyy = String(year).padStart(4, "0");
  return order === "mdy" ? `${mm}/${dd}/${yyyy}` : `${dd}/${mm}/${yyyy}`;
}

/** The day a complete text names; null while partial or for a day no month has. */
export function readInputDate(text: string, order: IDateOrder): IsoDate | null {
  const match = FULL.exec(text.trim());
  if (!match) return null;
  const [, first, second, year] = match;
  const [month, day] = order === "mdy" ? [first, second] : [second, first];
  const date = `${year}-${month}-${day}`;
  return isIsoDate(date) ? date : null;
}
